// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip-text{font-size:16px;visibility:hidden;width:100%;background-color:#000;color:#fff;text-align:center;border-radius:6px;padding:5px 0;position:absolute;z-index:1;top:100%;left:50px;margin-left:-60px}.fa-question-circle:hover+.tooltip-text,.show-tooltip:hover+.tooltip-text{visibility:visible}@media only screen and (max-width:768px){.tooltip-text{left:60px!important}}", ""]);
// Exports
module.exports = exports;
